// extracted by mini-css-extract-plugin
export default {"noImageContainer":"noImageContainer--mp-nYQYS","noImage":"noImage--mp-gUbsG"};